// MORGENS csapat-szín paletta — a legacy CRM `FormatterService::getColors` 1:1 másolata (üzleti paritás).
// A csapat `color` mezője egy NEVESÍTETT token (pl. `grove`, `coral`); ez adja az avatar-háttért/gyűrűt és a
// csapat-badge színét. A RÉSZLEGNEK nincs színe (a hierarchia: részleg → csapat → beosztás, a szín a csapatén él).
// A `text` a háttéren olvasható szövegszín (a legacy `darkText`-je ott, ahol a háttér világos
// → sötét szöveg; egyébként fehér). Ismeretlen/hiányzó token → `gray` (a legacy default).
export interface TeamColor {
  /** Háttérszín (avatar-monogram háttér, badge háttér, gyűrű). */
  bg: string;
  /** A háttéren olvasható szövegszín (monogram/badge felirat). */
  text: string;
}

const PALETTE: Record<string, TeamColor> = {
  burgundy: { bg: '#9B3A3A', text: '#ffffff' },
  coral: { bg: '#FF838A', text: '#030712' },
  honey: { bg: '#F4B942', text: '#030712' },
  kiwi: { bg: '#dbf183', text: '#030712' },
  grove: { bg: '#38bd6d', text: '#030712' },
  mint: { bg: '#7FD6C2', text: '#030712' },
  forest: { bg: '#0c4a42', text: '#ffffff' },
  lagoon: { bg: '#38adbd', text: '#030712' },
  iris: { bg: '#5B5FC7', text: '#ffffff' },
  midnight: { bg: '#1E2F3A', text: '#ffffff' },
  steel: { bg: '#8FA3B8', text: '#030712' },
  gray: { bg: '#6b7280', text: '#ffffff' },
};

const FALLBACK: TeamColor = PALETTE.gray!;

/** A választható csapat-szín-tokenek (a paletta kulcsai, stabil sorrendben) — a szín-választó forrása.
 *  Így a szín-készlet EGY helyen (a paletta) él; a form innen sorolja fel az opciókat (nincs hardcode hex a UI-ban). */
export const TEAM_COLOR_TOKENS: readonly string[] = Object.keys(PALETTE);

/** Egy csapat-szín-token feloldása {bg,text}-re; ismeretlen/üres → `gray` (legacy default). */
export function teamColor(token: string | null | undefined): TeamColor {
  if (!token) return FALLBACK;
  return PALETTE[token.trim().toLowerCase()] ?? FALLBACK;
}

/**
 * A csapat-BADGE inline stílusa — a design-rendszer badge-mintája (PUHA tónus: soft háttér + olvasható szöveg),
 * a csapat színéből. A háttér a teli színt ~16%-os áttetsző tintté lágyítja (téma-tudatos: a felülettel keveredik),
 * a szöveg a színt a téma-tintával keveri (világosban sötét / sötétben világos) → nincs erős fekete, ÉS a szélső
 * színek (kiwi/forest) is olvashatók mindkét módban. Így egyezik a többi (success/violet/…) badge-dzsel.
 */
export function teamBadgeStyle(token: string | null | undefined): {
  backgroundColor: string;
  color: string;
} {
  const { bg } = teamColor(token);
  return {
    backgroundColor: `color-mix(in srgb, ${bg} 16%, transparent)`,
    // A szöveg a csapat-színt a TÉMA-tintával keveri (világosban sötét, sötétben világos: `--dept-badge-ink`) →
    // a nagyon világos (kiwi) ÉS a nagyon sötét (forest/midnight) színek is olvashatók MINDKÉT módban.
    color: `color-mix(in srgb, ${bg} 62%, var(--dept-badge-ink))`,
  };
}
